<template>
  <div class="register-form">
    <div class="form-box">
      <div class="main-form-box">
        <div class="styled-header"></div>
        <form class="form-container" @submit="submitForm">
          <div class="form-grid">
            <div class="input-box">
              <input
                type="text"
                v-bind:class="['input', formErrors.firstname ? 'error' : '']"
                v-model="regParams.firstname"
                placeholder="First name"
                required
              />
              <small v-if="formErrors.firstname" class="error">
                {{ formErrors.firstname }}
              </small>
            </div>
            <div class="input-box">
              <input
                type="text"
                v-bind:class="['input', formErrors.lastname ? 'error' : '']"
                placeholder="Other names"
                v-model="regParams.lastname"
                required
              />
              <small v-if="formErrors.lastname" class="error">
                {{ formErrors.lastname }}
              </small>
            </div>
          </div>
          <div class="form-grid">
            <div class="input-box">
              <input
                type="text"
                v-bind:class="['input', formErrors.phonenumber ? 'error' : '']"
                placeholder="Phone Number"
                v-model="regParams.phonenumber"
                required
              />
              <small v-if="formErrors.phonenumber" class="error">
                {{ formErrors.phonenumber }}
              </small>
            </div>
            <div class="input-box">
              <select
                v-bind:class="['select', formErrors.gender ? 'error' : '']"
                v-model="regParams.gender"
                placeholder="Select Gender"
                required
              >
                <option disabled value="">Select Gender</option>
                <option :value="1">Male</option>
                <option :value="0">Female</option>
              </select>
              <small v-if="formErrors.gender" class="error">
                {{ formErrors.gender }}
              </small>
            </div>
          </div>
          <div class="input-box">
            <input
              type="email"
              v-bind:class="['input', formErrors.email ? 'error' : '']"
              placeholder="Email Address"
              v-model="regParams.email"
              required
            />
            <small v-if="formErrors.email" class="error">
              {{ formErrors.email }}
            </small>
          </div>
          <div class="form-grid">
            <div class="input-box">
              <input
                type="password"
                v-bind:class="['input', formErrors.password ? 'error' : '']"
                placeholder="Password"
                v-model="regParams.password"
                required
              />
              <small v-if="formErrors.password" class="error">
                {{ formErrors.password }}
              </small>
            </div>
            <div class="input-box">
              <input
                type="password"
                v-bind:class="['input', formErrors.cpassword ? 'error' : '']"
                placeholder="Confirm Password"
                v-model="regParams.cpassword"
                required
              />
              <small v-if="formErrors.cpassword" class="error">
                {{ formErrors.cpassword }}
              </small>
            </div>
          </div>
          <div class="input-box">
            <select
              v-bind:class="['select']"
              v-model="referralSource"
              placeholder="Select a referral"
            >
              <option disabled value="">Select a referral</option>
              <option value="Sunfi">Sunfi</option>
              <option value="Others">Others</option>
              <option value="None">None</option>
            </select>
          </div>
          <div class="form-grid" v-if="referralSource === 'Others'">
            <div class="input-box">
              <input
                type="text"
                v-bind:class="['input', formErrors.referralname ? 'error' : '']"
                placeholder="Referral Name"
                v-model="regParams.referralname"
              />
              <small v-if="formErrors.referralname" class="error">
                {{ formErrors.referralname }}
              </small>
            </div>
            <div class="input-box">
              <input
                type="text"
                v-bind:class="['input', formErrors.referralcontact ? 'error' : '']"
                placeholder="Referral Contact"
                v-model="regParams.referralcontact"
              />
              <small v-if="formErrors.referralcontact" class="error">
                {{ formErrors.referralcontact }}
              </small>
            </div>
          </div>
          <div class="input-box" v-show="this.showReferral">
            <input
              type="text"
              v-bind:class="['input', formErrors.affiliatecode ? 'error' : '']"
              placeholder="Referral code"
              v-model="regParams.affiliatecode"
              id="button-2"
            />
            <b-tooltip target="button-2" placement="left" triggers="focus">
              Optional
            </b-tooltip>
          </div>
          <p>
            <input
              type="checkbox"
              name="referralcode"
              id="referralcode"
              @click="onToggelReferral"
            />
            <label for="referralcode">Do you have a referral code?</label>
          </p>
          
          <!-- @click="add@ForPromotionalMaterials" -->
          <p style="display:flex">
            <input
              type="checkbox"
              name="promotionalMaterials"
              id="promotionalMaterials"
              />
            <label for="promotionalMaterials" style="margin-left:3px;">Subscribe for our promotional materials</label>
          </p>

          <button v-if="loader" class="form-button">
            <div class="submit-gif">
              <div
                class="spinner-border"
                style="width: 2rem; height: 2rem"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </button>
          <button @click="submitForm" v-else class="form-button">
            Sign up
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import axios from "axios";
import { mapActions } from "vuex";
import ArnergyFormInput from "../pages/kitchen/ArnergyFormInput";
import ArnergyLoader from "../pages/kitchen/ArnergyLoader";

export default {
  name: "RegisterForm",
  components: {
    ArnergyLoader,
    ArnergyFormInput
  },
  data() {
    return {
      showReferral: false,
      regParams: {
        firstname: null,
        lastname: null,
        phonenumber: null,
        gender: "",
        username: null,
        affiliatecode: null,
        email: null,
        password: null,
        cpassword: null,
        referralname: null,
        referralcontact: null
      },
      customerEmail: "",
      mailSent: false,
      formErrors: [],
      loader: false,
      referralSource: ""
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {},
  methods: {
    ...mapActions(["setUserSession", "setAccess"]),
    validateReg() {
      const formErrors = [];

      for (let [field, value] of Object.entries(this.regParams)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }

        switch (field) {
          case "firstname":
            if (value === "null" || value === "") {
              formErrors[field] = "firstname cannot be empty.";
            }
            break;
          case "lastname":
            if (value === "null" || value === "") {
              formErrors[field] = "lastname cannot be empty.";
            }
            break;
          case "email":
            if (value === "null" || value === "") {
              formErrors[field] = "Email cannot be empty.";
            } else if (!this.isEmail(value)) {
              formErrors[field] = "Not a valid email.";
            }
            break;
          case "cemail":
            if (value !== "null" || value !== "") {
              if (value !== this.regParams.email) {
                formErrors[field] = "Emails did not match.";
              }
            }
            break;
          case "password":
            if (value === "null" || value === "") {
              formErrors[field] = "Password cannot be empty.";
            }
            break;
          case "cpassword":
            if (value !== "null" || value !== "") {
              if (value !== this.regParams.password) {
                formErrors[field] = "Password did not match.";
              }
            }
            break;
          case "referralname":
            break;
          case "referralcontact":
            if (value !== "null" && value !== "" && isNaN(value)) {
              formErrors[field] = "Referral Contact must be a number.";
            }
            break;
          case "phonenumber":
            if (value === "null" || value === "") {
              formErrors[field] = "Phone cannot be empty.";
            }
            break;
          case "gender":
            if (value === "null" || value === "") {
              formErrors[field] = "Gender cannot be empty.";
            }
            break;
          case "customerType":
            if (value === "null" || value === "") {
              formErrors[field] = "Please select a Customer type.";
            }
            break;
          case "businessAddress":
            if (
              this.regParams.customerType == "Corporate" &&
              (value === "null" || value === "")
            ) {
              formErrors[field] = "Business Address cannot be empty.";
            }
            break;
          case "businessName":
            if (
              this.regParams.customerType == "Corporate" &&
              (value === "null" || value === "")
            ) {
              formErrors[field] = "Business Name cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      return formErrors;
    },
    isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    async submitForm(e) {
      e.preventDefault();

      if (this.referralSource === "Sunfi") {
        this.regParams.referralname = "Sunfi";
        this.regParams.referralcontact = null;
      } else if (this.referralSource === "None") {
        this.regParams.referralname = null;
        this.regParams.referralcontact = null;
      }

      this.formErrors = this.validateReg();
      if (Object.keys(this.formErrors).length > 0) return;
      console.log("Registration Params:", this.regParams);

      const data = {
        ...this.regParams,
        roletype: this.regParams.customerType,
        dateofbirth: new Date(),
        wallet: 0,
        realm: "",
        username: this.regParams.email,
        ccemails: this.regParams.email
      };

      if (this.referralSource === "None") {
        delete data.referralname;
        delete data.referralcontact;
      }

      var str = JSON.stringify(data);
      const tempReg = JSON.parse(str);

      const HTTP = this.$httpUtils.FASTHTTP;

      try {
        this.loader = true;
        let res = await HTTP.post("/auth/register-otp", tempReg)
          .then(res => {
            console.log(res);
            if (res.data) {
              this.loader = false;
              this.mailSent = true;
              this.customerEmail = this.regParams.email;
              this.regParams = {};

              // GTM track user action
              if (this.isProduction()) {
                this.$gtag.event("conversion", {
                  send_to: "AW-481803421/PR4_CMWJ7eMDEJ353uUB"
                });
              }

              this.$router.push({ name: "EmailVerified", params: res.data });
            }
          })
          .catch(error => {
            // let { response } = error;
            if (
              error.response.data.detail[0].msg &&
              error.response.data.detail[0].msg ==
                "ensure this value has at least 8 characters"
            ) {
              const message = "Password must be atleast 8 characters";
              this.showErrorMsg({ message: message });
              this.loader = false;
            } else {
              const message = error.response.data.detail;
              this.showErrorMsg({ message: message });
              this.loader = false;
            }
          });
      } catch (error) {
        this.errorMessage = "Something went wrong, please try again.";
        this.showErrorMsg({ message: this.errorMessage });
        this.loader = false;
      }
    },
    onToggelReferral() {
      this.showReferral = !this.showReferral;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_reduced_variables.scss";

h3,
p,
label,
ul,
li {
  margin: 0;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  width: 100%;
  @media (max-width: 480px) {
    display: grid;
    grid-template-columns: 1fr;
    margin-bottom: 24px;
  }
}

.register-container {
  width: 100%;
  background-color: white;
  display: flex;
}

img.logo-cover {
  position: absolute;
  top: 3.75rem;
  left: 3.75rem;
  z-index: 1;
}

.slider-base {
  width: 53%;
  text-align: center;
}

.slider-text > h3 {
  font-size: 1.5rem/2.5.5rem;
  margin-bottom: 0.625rem;
}

.slider-text > p {
  font-size: 1rem/1.5rem;
  margin-bottom: 2rem;
}

.slider-state {
  list-style-type: none;
  display: flex;
  width: fit-content;
  margin: 0 auto;
}

.slider-state li {
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  margin-right: 0.625rem;
  background-color: #dddddd;
  opacity: 0.5;
}

.slider-state li:last-child {
  margin-right: 0rem;
}

.slider-state li.active {
  width: 1.375rem;
  border-radius: 0.31rem;
  background-color: white;
}

.form-side {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  flex: 1;
  padding: 6rem 9rem;
}

.register-form {
  color: #727272;
}

.form-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alt-text {
  font-size: 1.125rem/1.5rem;
  color: #727272;
  margin-left: auto;
  margin-bottom: 3.5rem;
}

.signup-link {
  color: #fe7a11;
}

.main-form-box {
  width: 100%;
}

.form-container {
  background: white;
  border-radius: 1.875rem;
  //   border: 0.1rem solid rgba(221, 221, 221, 0.5);
  width: 100%;
  padding: 20px;
  margin: auto;
  max-width: 550px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.form-container > h3 {
  font-weight: 700;
  font-size: 24px;
  line-height: 38.9px;
  color: #000000;
}

.form-container > p {
  font-size: 1.125rem/1.5rem;
  margin-bottom: 2.5rem;
  line-height: 24px;
}

.input-box {
  position: relative;
  margin-bottom: 1.8rem;
  width: 100%;
}

.input-box:last-child {
  margin-bottom: 0rem;
  // background-color: #727272;
}

.input-box input,
.input-box select {
  width: 100%;
  border: 1px solid rgba(90, 86, 86, 0.5);
  padding: 14px 22px;
  height: 52px;
  border-radius: 10px;
  font-size: 16px;
  line-height: 1.5rem;
  color: #000000;
}

.input-box input:focus,
.input-box select:focus {
  border: 1px solid #0892d0;
}

.input-box input.error,
.input-box select.error {
  border: 1px solid #f83c1e;
}

.input-box input::placeholder,
.input-box select::placeholder {
  color: #727272;
}

small.error {
  color: #f83c1e;
}

.input-box label {
  font-size: 16px;
  font-weight: 100;
  position: absolute;
  top: 1.5rem;
  left: 22px;
  color: #727272;
}

.form-button {
  padding: 0.875rem 3rem;
  border-radius: 5px;
  background-color: #0892d0;
  border: none;
  color: #ffffff;
  font-size: 16px;
  line-height: 24px;
  margin: auto;
  // margin-top: 2.5rem;
  align-self: flex-end;
}

.form-button:hover {
  transform: scale(0.95);
}

.form-loader {
  align-self: flex-end;
}

.submit-gif {
  color: #ffffff;
  text-align: center;
  border: 0;
  background-color: transparent;
}

.modal-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-body {
  width: 40%;
  max-width: 480px;
  margin: 105px auto;
  padding: 45px;
  background: #ffffff;
  box-shadow: 0px 6px 4px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  font-family: "DM Sans";
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image {
  margin: 36px auto;
  width: 120px;
}

.logo {
  width: 125px;
}

b {
  font-weight: bold;
  font-family: inherit;
}

.submit-button {
  background: #0892d0;
  border-radius: 5px;
  width: 207px;
  height: 51px;
  margin: 31px auto;
  border: none;
  font-family: inherit;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
}

.close {
  margin: 0px 0px 0px auto;
}

.text {
  width: 90%;
  font-family: inherit;
  font-size: 16px;
  text-align: center;
  color: #727272;
  line-height: 24px;
}

.title {
  font-family: inherit;
  font-weight: 700;
  font-size: 24px;
  line-height: 39px;
}

.info-text {
  padding: 6px 24px;
  background: #fefce8;
  color: #eab308;
  border-radius: 6px;
  margin: 12px 0;
  display: block;
}

@media (max-width: 1100px) {
}
</style>



// WEBPACK FOOTER //
// src/components/forms/register-form.vue